import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-pagetemplate',
    templateUrl: './pagetemplate.component.html',
    styleUrls: ['./pagetemplate.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PagetemplateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
